// Header Constants
export const JOIN_MEDIAMAX = 'Start now'
export const LOGIN = 'Login'
export const LOGOUT = 'Logout'

// Footer Constants
export const FOOTER_EMAIL = 'mediamax@blinkit.com'
export const FOOTER_CONTACT_LABEL = 'Contact us: '
export const USEFUL_LINKS_TITLE = 'Useful links'

export const USEFUL_LINKS = {
  firstColumn: ['About', 'Careers', 'Blog', 'Press', 'Lead', 'Value'],
  secondColumn: ['Privacy', 'Terms', 'FAQs', 'Security', 'Mobile', 'Contact'],
  thirdColumn: ['Partner', 'Franchise', 'Seller', 'Warehouse', 'Deliver', 'Resources'],
}

// Login Constants
export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const LOGIN_TEXT = {
  welcomeTitle: "Welcome! Let's log you in",
  emailPlaceholder: 'Enter your email ID',
  sendOtpButton: 'Send OTP',
  closeAriaLabel: 'Close',
  invalidEmailError: 'Please enter a valid email address',
  blinkitLogoAlt: 'blinkit-round-logo',
  closeIconAlt: 'Close',
}

// OTP Constants
export const OTP_TEXT = {
  verificationTitle: 'OTP Verification',
  otpSentMessage: (email: string) => `OTP has been sent to ${email}`,
  validityMessage: 'Valid for 5 minutes',
  verifyButton: 'Verify OTP',
  verifyingButton: 'Verifying...',
  incompleteOtpError: 'Please enter complete OTP',
  didNotReceiveText: 'Did not receive OTP? ',
  resendButton: 'Resend OTP',
  blinkitLogoAlt: 'blinkit-round-logo',
  closeIconAlt: 'Close',
  closeAriaLabel: 'Close',
  resendSuccessMessage: 'An OTP has been resent to your email',
}

// Brand Selection Modal Constants
export const BRAND_SELECTION_MODAL_TEXT = {
  alreadyHaveAccessTag: 'Already have access',
  brandSelectionModalSubtitle: 'Ensure brand selection is accurate as it will be reviewed',
  title: 'Select the brands you manage',
  subtitle: "Looks like you're new here",
  addBrandTitle: 'Select the brands you manage',
  newBrandAccess: 'New brand access',
  brandsPageTitle: 'Brands',
  homeBreadcrumb: 'Home',
  overview: 'Overview',
  placeholder: 'Select brands',
  searchPlaceholder: 'Search by brand name',
  selectedBrandsLabel: 'Select brands',
  selectedBrandsAerobarContent: (maxBrandsPerRequest: number) =>
    `Up to ${maxBrandsPerRequest} brands can be selected per request`,
  clearAllLabel: 'Clear All',
  viewOnlySelectedLabel: 'View only selected brands',
  requestAccessButton: 'Request access',
  processingButton: 'Processing...',
  closeAriaLabel: 'Close modal',
  blinkitLogoAlt: 'Blinkit Logo',
  closeIconAlt: 'Close',
  blueInfoOutlineAlt: 'info outline',
  addNewBrandLink: 'Add a new brand',
  brandFetchError: 'Something went wrong while fetching brands. Please retry.',
}

export const BRAND_SELECTION_PAGE_SIZE = 100

// Status Modal Constants
export const STATUS_MODAL_TEXT = {
  pending: {
    title: 'Your previous request is still being processed',
    description:
      'Our ads team is reviewing your submission. We’ll email you with the next steps shortly.',
  },
  accessRequested: {
    title: 'Your request is under review',
    description:
      'Our ads team is reviewing your submission. We’ll email you with the next steps shortly.',
  },
  approved: {
    title: 'Your request has been approved!',
    description: (brandCount: number) =>
      brandCount === 1
        ? 'You now have access to the selected brand.'
        : 'You now have access to the selected brands.',
    additionalText: 'You can start creating ads for your brands',
  },
  rejected: {
    description: 'Your previous request was rejected',
  },
}

// Shown when a brand URL can't be opened, e.g. a shared link for a brand the user has no access to.
export const BRAND_ACCESS_GUARD_TEXT = {
  DENIED_TITLE: "You don't have access to this brand",
  DENIED_DESCRIPTION:
    'Request access to it from the home page, or check the link with whoever shared it.',
  ERROR_TITLE: "Couldn't load this brand",
  ERROR_DESCRIPTION: 'Check your connection and try again.',
  HOME_LABEL: 'Go to home',
  RETRY_LABEL: 'Retry',
}

export const BRAND_ACCESS_REJECTION_REASON_PREFIX = 'Reason: '

// Brand Access Status Constants
// API codes for brand access status.
export const BRAND_ACCESS_STATUS = {
  APPROVED: 'BRAND_ACCESS_STATUS_APPROVED',
  NOT_REQUESTED: 'BRAND_ACCESS_STATUS_NOT_REQUESTED',
  REJECTED: 'BRAND_ACCESS_STATUS_REJECTED',
  PENDING: 'BRAND_ACCESS_STATUS_PENDING',
} as const

// Brand Access Error Modal Constants
export const BRAND_ACCESS_ERROR_MODAL_TEXT = {
  title: 'Something went wrong',
  description: "We couldn't fetch your brand access status. Please try again.",
  retryButton: 'Retry',
  retryingButton: 'Retrying...',
} as const

// Error Messages Constants
export const ERROR_MESSAGES = {
  sendOtpFailed: 'Failed to send OTP. Please try again.',
  verifyOtpFailed: 'Failed to verify OTP. Please try again.',
  emailNotFound: 'Email not found. Please try again.',
  noEmailForResend: 'No email found to resend OTP',
  brandAccessStatusError: 'Error fetching brand access status:',
  verifyOtpError: 'Error verifying OTP:',
  sendOtpError: 'Error sending OTP:',
} as const

export const SENTRY_ENV = {
  production: 'production',
  preProd: 'pre-prod',
  development: 'development',
} as const

export const TAB_MEDIA_QUERY = '(max-width: 1023px)'
